const languageinfo = {
    en: {name: "English", image: require("./img/flags/en.png")},
    de: {name: "Deutsch", image: require("./img/flags/de.png")},
    it: {name: "Italiano", image: require("./img/flags/it.png")},
    fr: {name: "Français", image: require("./img/flags/fr.png")},
    nl: {name: "Nederlands", image: require("./img/flags/nl.png")},
    es: {name: "Español", image: require("./img/flags/es.png")}
};

export default languageinfo;